var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81484 9.87C7.71484 9.86 7.59484 9.86 7.48484 9.87C5.10484 9.79 3.21484 7.84 3.21484 5.44C3.21484 2.99 5.19484 1 7.65484 1C10.1048 1 12.0948 2.99 12.0948 5.44C12.0848 7.84 10.1948 9.79 7.81484 9.87Z",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0655 3C17.0055 3 18.5655 4.57 18.5655 6.5C18.5655 8.39 17.0655 9.93 15.1955 10C15.1155 9.99 15.0255 9.99 14.9355 10",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.815 13.56C0.395 15.18 0.395 17.82 2.815 19.43C5.565 21.27 10.075 21.27 12.825 19.43C15.245 17.81 15.245 15.17 12.825 13.56C10.085 11.73 5.575 11.73 2.815 13.56Z",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9951 19C17.7151 18.85 18.3951 18.56 18.9551 18.13C20.5151 16.96 20.5151 15.03 18.9551 13.86C18.4051 13.44 17.7351 13.16 17.0251 13",
    stroke: "#86929D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9fcddae3d8d4ce8dc783422153ed960b.svg";
export { ForwardRef as ReactComponent };